{
  "name": "ecoacsa-workspace-v2",
  "version": "2.0.18",
  "scripts": {
    "ng": "ng",
    "bump-version": "npm version patch -m %s",
    "deploy:develop": "ng build admin --configuration=development --output-hashing=all  && firebase deploy --only hosting -m $npm_package_version --project=ecoacsa-develop",
    "deploy:prod": "ng build admin --configuration=production --output-hashing=all  && firebase deploy --only hosting -m $npm_package_version --project=ecoacsa-nature",
    "start": "ng serve",
    "build": "ng build",
    "watch": "ng build --watch --configuration development",
    "test": "ng test"
  },
  "prettier": {
    "overrides": [
      {
        "files": "*.html",
        "options": {
          "parser": "angular"
        }
      }
    ]
  },
  "private": true,
  "dependencies": {
    "@angular/common": "^20.1.0",
    "@angular/compiler": "^20.1.0",
    "@angular/core": "^20.1.0",
    "@angular/fire": "^20.0.1",
    "@angular/forms": "^20.1.0",
    "@angular/platform-browser": "^20.1.0",
    "@angular/router": "^20.1.0",
    "@date-fns/tz": "^1.2.0",
    "@ngneat/until-destroy": "^10.0.0",
    "@ngx-translate/core": "^16.0.4",
    "@ngx-translate/http-loader": "^16.0.1",
    "@primeuix/themes": "^1.2.1",
    "@tailwindcss/postcss": "^4.1.11",
    "chart.js": "^4.5.0",
    "chartjs-plugin-datalabels": "^2.2.0",
    "date-fns": "^4.1.0",
    "date-fns-tz": "^3.2.0",
    "deep-object-diff": "^1.1.9",
    "exceljs": "^4.4.0",
    "file-saver": "^2.0.5",
    "lodash-es": "^4.17.21",
    "ng-let": "^20.0.1",
    "ngx-avatars": "^1.10.0",
    "ngx-date-fns": "^12.0.1",
    "ngx-permissions": "^19.0.0",
    "postcss": "^8.5.6",
    "primeflex": "^4.0.0",
    "primeicons": "^7.0.0",
    "primeng": "^20.0.0",
    "quill": "^2.0.3",
    "remixicon": "^4.6.0",
    "rxjs": "~7.8.0",
    "ssf": "^0.11.2",
    "tailwindcss": "^4.1.11",
    "tailwindcss-primeui": "^0.6.1",
    "tslib": "^2.3.0"
  },
  "devDependencies": {
    "@angular/build": "^20.1.3",
    "@angular/cli": "^20.1.3",
    "@angular/compiler-cli": "^20.1.0",
    "@types/jasmine": "~5.1.0",
    "@types/lodash-es": "^4.17.12",
    "jasmine-core": "~5.8.0",
    "karma": "~6.4.0",
    "karma-chrome-launcher": "~3.2.0",
    "karma-coverage": "~2.2.0",
    "karma-jasmine": "~5.1.0",
    "karma-jasmine-html-reporter": "~2.1.0",
    "ng-packagr": "^20.1.0",
    "prettier": "^3.6.2",
    "typescript": "~5.8.2"
  }
}
